import * as React from 'react';
import {Typography, WithStyles, withStyles } from '@material-ui/core';
import { IEcoPurchase, IEcoSplitSetting} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";
import { ecoContainerStyle } from './Container.style';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import ChatIcon from '@material-ui/icons/QuestionAnswerOutlined';
import {EditOutlined} from "@material-ui/icons";
import { getPercentage, getPurchaseBalance, isDeletedByNonCreator, } from '@helpers/EconomyHelper';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ChatButton from './ChatButton';
import { ChatType } from '@app-types/websocket/chat.types';
import { styleColors } from 'src/main.style';

const tn = TranslateNew.getInstance();

interface IProps extends RouteComponentProps, WithStyles<typeof ecoContainerStyle>
{
    purchase: IEcoPurchase;
    family: IFamilyMember[];
    userId:number;
    currency:string;
    settings:IEcoSplitSetting[];
    edit: (purchase:IEcoPurchase) => void;
    seen: (id:number) => void;
    scrollTime:number;
    waitForPurchaseChat:(id:number) => void;
}

interface IState
{
    explain: boolean;
    seenCalled: boolean;
}

class ListItemPurchase extends React.Component<IProps,IState> {

    private myRef: HTMLDivElement | null = null;

    constructor(props: IProps) {
        super(props);
    
        this.state = {
            explain: false,
            seenCalled: false,
        };
    
    }

    public componentDidMount() {
        if (this.state.seenCalled === false 
          && this.props.purchase.seenBy.indexOf(this.props.userId) === -1) {
          if (this.isInViewport()) {
            this.setState({seenCalled:true});
            this.props.seen(this.props.purchase.id);
          }
        }
    }

    public componentDidUpdate(prevProps: Readonly<IProps>): void {
        if (this.state.seenCalled === false 
            && prevProps.scrollTime !== this.props.scrollTime
            && this.props.purchase.seenBy.indexOf(this.props.userId) === -1) 
        {
            if (this.isInViewport()) {
              this.setState({seenCalled:true});
              this.props.seen(this.props.purchase.id);
            }
          }
    }

    public render() { 
        const {userId, classes, purchase, settings, family} = this.props;
        const doneBy = this.props.family.find((mem) => mem.id === purchase.paidBy);
        const balance = getPurchaseBalance(purchase, userId, settings);
        const balanceColor = balance > 0
            ? styleColors.callGreen
            : balance < 0 ? styleColors.coralRed : styleColors.greyDark2;
        const declinedToShare = isDeletedByNonCreator(purchase);

        let chatButton:JSX.Element|undefined;
        if (purchase.disputedBy !== undefined) {
            chatButton = <ChatButton referenceObject={purchase.id} family={family} chatId={purchase.chatId} chatType={ChatType.PURCHASE_CHAT}
                waitForPurchaseChat={this.props.waitForPurchaseChat}
                title = {tn.lang.purchaseRegardingTitle(purchase.title)} msg = {purchase.description?purchase.description:""}/>;
        } 

        return (
            <div className={classes.cardContent} id={"pur"+purchase.id}
                ref={(el) => this.myRef = el}
                style={(!purchase.seenBy.includes(userId) && !purchase.deleted)
                    ?{ boxShadow: `0px 0px 20px ${styleColors.redShadow23}`, backgroundColor: styleColors.brightCoralTint12, }
                    :{ boxShadow: '0px 0px 20px rgb(255 0 0 / 0%)', backgroundColor: styleColors.transparent,
                        opacity: purchase.deleted ? 0.5 : 1, }}>
                <div style={{position:'absolute', width:'70%', height: '100%' , zIndex: 2, top:0, left:0}} 
                    onClick={() => this.props.edit(purchase)} />
                <div style={{position:'absolute', width:'30%', height: '100%' , zIndex: 2, top:0, right:0}} 
                    onClick={() => this.explain(purchase.id)}/>
                <div className={classes.cardContentListItem}  style={{maxWidth:chatButton===undefined?'100%':'calc(100% - 36px)',
                    minWidth:chatButton===undefined?'100%':'calc(100% - 36px)'}}>
                    <div className={classes.itemTopRow}>
                        <div className={classes.body2} style={{cursor:'pointer'}}>
                            {tn.formatDateShort(new Date(purchase.date)) }
                        </div>
                    </div>

                    <div className={classes.itemTopRow}>
                        {doneBy && <ImgAvatar color={doneBy.color} imgName={doneBy.avatar}  imgUrl={doneBy.imageAvatar?doneBy.avatarURL:undefined}
                            style={{width:14, height:14}} altText={doneBy.firstName} />}
                        <div className={classes.parentWithTraillingText} >
                            <Typography className={[ classes.body1, classes.traillingTittle].join(' ')}
                                style={{cursor:'pointer', textDecoration: purchase.deleted ? 'line-through' : 'none'}}>
                                {purchase.title}
                            </Typography>
                        </div>
                        <Typography className={classes.body1} component="div"
                            style={{cursor:'pointer', color: balanceColor, textDecoration: purchase.deleted ? 'line-through' : 'none'}}>
                            {tn.formatNumber(balance, this.props.currency)}
                        </Typography>                                 
                    </div>
                    <div className={classes.itemBottomRow}>
                        <Typography component="div" color="textSecondary" className={classes.body2}
                            style={{marginRight:20, cursor:'pointer', color: declinedToShare ? styleColors.coralRed : undefined}}>
                            {purchase.deleted
                                ? (declinedToShare ? tn.lang.ecoDeclinedToShare : tn.lang.ecoDeletedByCreator)
                                : this.renderExplanation(purchase, this.state.explain)}
                        </Typography>
                        {!purchase.deleted &&
                            <Typography
                                component="div" style={{cursor:'pointer'}} color="textSecondary" className={classes.body2}>
                                {this.state.explain?("     "+tn.lang.OK):(tn.lang.explain)}
                            </Typography>}
                    </div>
                </div>
                {chatButton}
            </div>
        );
    }

    private isInViewport(offset = 0) {
        if (!this.myRef) { return false; }
        const rect = this.myRef.getBoundingClientRect();
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
    
        if (!(rect.left >= 0 && rect.right <= viewWidth)) { return false; }
        if (!(rect.top >= 0 && (rect.top + 50) <= viewHeight)) { return false; } // if 50 pixels has been seen thats enough
    
        return true;
    }

    private renderExplanation(purchase:IEcoPurchase, shouldExplain:boolean) {
        const myPartInSharedAccount = getPercentage(this.props.userId, purchase.date, this.props.settings);
        const mySplit = purchase.split.find((spl) => spl.accountId === this.props.userId);
        const myPercentage = (mySplit === undefined)?0:mySplit.percentage;
        const howMuchIShouldPay = (myPercentage*purchase.amount)/100;
        const balance = getPurchaseBalance(purchase,this.props.userId,this.props.settings); 


        if (shouldExplain) {
            if (purchase.fromSharedAccount) {
                if (myPercentage === myPartInSharedAccount) {
                    return tn.lang.ecoExplainFromSharedAccountNormalPurchase(myPercentage, myPartInSharedAccount, 
                        purchase.paidBy, this.props.userId, this.props.family, purchase.amount);
                } else {
                    return tn.lang.ecoExplainFromSharedAccountNOTNormalPurchase(myPercentage, myPartInSharedAccount, 
                        purchase.paidBy, this.props.userId, this.props.family, purchase.amount, balance, this.props.currency);
                }
            } else if (purchase.paidBy === this.props.userId) {
                return tn.lang.ecoExplainFromMyPrivateAccountPurchase(myPercentage, purchase.amount, balance, this.props.currency,howMuchIShouldPay);
            } else {
                return tn.lang.ecoExplainFromCoparentPrivateAccountPurchase(purchase.paidBy, this.props.family, myPercentage, purchase.amount,  
                    this.props.currency,howMuchIShouldPay);
            }
        } else {
            return (
                <>
                    {tn.lang.ecoPurchaseSubtitle(myPercentage, purchase.amount, this.props.currency)}
                    {(!!purchase.description && purchase.description.length > 0) 
                        && purchase.description}
                    {(!!purchase.images && purchase.images.length > 0) 
                        && <ImageOutlinedIcon style={{fill:styleColors.warmGrey, fontSize:'12px'}}  />}
                    {(purchase.chatId !== undefined) 
                        && <ChatIcon style={{fill:styleColors.warmGrey, fontSize:'12px'}}  />}
                </>
            );
        }
    }

    private explain(purchaseId:number) {
        this.setState({explain:!this.state.explain});
    }
}




export default withRouter(withStyles(ecoContainerStyle)(ListItemPurchase));



// WEBPACK FOOTER //
// ./src/components/economy/ListItemPurchase.tsx